import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';

export const Container = styled.ol`
    display: flex;
    flex-direction: column;
    max-width: 600px;
    gap: 16px;

    ${mediaQueries.laptop} {
        margin-top: 8px;
    }
`;
